//velocity : Function to push data into datalayer for event section intro for current disease
function sectionIntroGtm (eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event : 'self_assessment_section_intro_cta_clicked',
    ...eventData
  })
}

//velocity : Function to push data of sorted selected diseases for event - severity order of diseases
function diseaseSortOrderGtm (eventData){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
  event: 'self_assessment_category_sorted',
  question_title: "Please rank your concerns based on their severity",
  ...eventData
  });
}

//velocity : Function to push data of selected diseases for event - selected diseases
function selectedDiseasesGtm (eventData){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: 'self_assessment_category_selected',
   question_title: 'Please select the type of condition you are facing',    
   ...eventData
  });
}

//velocity : Function to push data of current question for event - assessment_question_answered
function questionAnswerGtm (eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: 'self_assessment_question_answered',  
   ...eventData
  });
}

//velocity : Function to push the data of platform selection into the data layer
function selectPlatform (eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: 'self_assessment_platform_selected',  
   ...eventData
  });
}

//velocity : Function to push data into data layer on successful completion of self-assessment
function completeAssessment (eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
   event: 'assessment_completed',  
   ...eventData
  });
}

